import * as analytics from 'analytics/Analytics';
import {Sequence} from 'components/Sequence';
import {MOLBIO_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import Protein from 'molbio/proteins/Protein';
import HistoryTabState, {HistoryTabStateAttributes} from 'molbio/visual-history/HistoryTabState';
import {TabStateDefaults} from 'Navigation';

interface VisualHistoryTabStateAttributes<Polymer extends Sequence | Protein>
  extends HistoryTabStateAttributes<Polymer> {}

interface VisualHistoryTabState<Polymer extends Sequence | Protein> {
  get<K extends keyof VisualHistoryTabStateAttributes<Polymer>>(
    key: K
  ): VisualHistoryTabStateAttributes<Polymer>[K];
  set<K extends keyof VisualHistoryTabStateAttributes<Polymer>>(
    attributeName: K,
    value: VisualHistoryTabStateAttributes<Polymer>[K],
    options?: Backbone.ModelSetOptions
  ): VisualHistoryTabState<Polymer>;
  set(obj: Partial<VisualHistoryTabStateAttributes<Polymer>>): VisualHistoryTabState<Polymer>;
}

class VisualHistoryTabState<Polymer extends Sequence | Protein> extends HistoryTabState<Polymer> {
  override onClick(): void {
    super.onClick();
    analytics.trackEvent(MOLBIO_ANALYTICS_ACTIONS.CLICKED_VISUAL_HISTORY_TAB, {
      polymerId: this.polymer().id,
    });
  }

  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Visual history',
      closeable: false,
      preferenceKey: 'visual-history',
    };
  }
}

export default VisualHistoryTabState;
